import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/channelpartners/components/channel-partner-types-section/channel-partner-types-section.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/apps/todoist-landing-pages/app/[locale]/channelpartners/components/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/channelpartners/components/layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["MoreInfo"] */ "/app/apps/todoist-landing-pages/app/[locale]/channelpartners/components/more-info-section/more-info-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MoreThanTheApp"] */ "/app/apps/todoist-landing-pages/app/[locale]/channelpartners/components/more-than-the-app-section/more-than-the-app-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Prefooter"] */ "/app/apps/todoist-landing-pages/app/[locale]/channelpartners/components/prefooter/prefooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuotesSection"] */ "/app/apps/todoist-landing-pages/app/[locale]/channelpartners/components/quotes-section/quotes-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsSection"] */ "/app/apps/todoist-landing-pages/app/[locale]/channelpartners/components/stats-section/stats-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/todoist-landing-pages/app/components/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/todoist-landing-pages/app/components/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/container-two-column/container-two-column.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/SectionHeader/SectionHeader.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/text-lock-up/text-lock-up.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/packages/marketist/dist/components/Button/Button.js");
